import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import {
  GenerateRebalancingPlanParams,
  RebalancingAccepted,
} from '@cast/types';

export const useGenerateRebalancePlanMutation = (
  clusterId: string
): UseMutationResult<
  AxiosResponse<RebalancingAccepted>,
  unknown,
  GenerateRebalancingPlanParams,
  unknown
> => {
  return useMutation({
    mutationFn: (params) =>
      apiClient.autoscaler.generateRebalancingPlan(
        {
          clusterId,
          body: params,
        },
        { timeout: 60_000 }
      ),
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
